<template lang="pug">
    layout

        // Main title
        title-component(
            slot="title"
            type="h2"
            :title="$t('coupons.create.title')"
        )

        // Create form
        create-form(ref="form")

        v-container(fluid grid-list-lg)
            v-layout(raw wrap)
                v-flex(xs12)

                    // Horizontal line
                    separator-component

                    div.controls
                        div

                            // Cancel button
                            button-component.ml-0(
                                :action="cancel"
                                :isLoading="isLoading"
                                :disabled="isLoading"
                                color="grey"
                                large
                                outline
                            ) {{ $t('defaultButtons.cancel') }}

                        div

                            // Submit button
                            button-component.mr-0.submit(
                                :action="submit"
                                :isLoading="isLoading"
                                :disabled="isLoading"
                                color="primary"
                                large
                            ) {{ $t('defaultButtons.save') }}
</template>

<script>
    import Layout from '../../Layout/Layout';
    import CreateForm from './CreateForm';
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        components: {
            Layout,
            CreateForm,
            TitleComponent: Title,
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        computed: {
            ...mapGetters('coupons', ['isLoading'])
        },
        methods: {
            ...mapActions('coupons', ['create', 'resetCoupon', 'cancel']),

            /**
             * Create Business account on submit
             * @returns {boolean}
             */
            async submit() {
                this.$refs.form.submit();
            }
        }
    };
</script>
